import VarsManager from './vars-manager'

/**
 * @interface BaseTokenStorage
 */

/**
 * @method
 * @name BaseTokenStorage#Write
 * @param {string} token
 */

/**
 * @method
 * @name BaseTokenStorage#Read
 * @returns {string}
 */

/**
 * @method
 * @name BaseTokenStorage#Remove
 */

class BaseTokenStorage {
  /** @type {string} */
  get tokenPath () {
    return VarsManager.TokenPath()
  }
}

export default BaseTokenStorage



// WEBPACK FOOTER //
// ./src/common/auth/storage/auth-token-base.js